import { getAuthHeaders } from '../../utils/authHeaders';

const API_URL = 'https://app.pvslimited.co.uk/api';

export const CERTIFICATE_EXHAUSTED_MESSAGE = 'No more allocated certificate numbers please contact management.';

export async function fetchCertificateStatus() {
  const response = await fetch(`${API_URL}/calor/certificate-status`, {
    headers: getAuthHeaders(),
  });

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body?.error || `Failed to load certificate status (${response.status})`);
  }
  return body;
}

export async function fetchCertificateRangeAdmin() {
  const response = await fetch(`${API_URL}/calor/certificate-range`, {
    headers: getAuthHeaders(),
  });

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body?.error || `Failed to load certificate range (${response.status})`);
  }
  return body;
}

export async function saveCertificateRange({ rangeStart, rangeEnd, numberingDisabledForTesting }) {
  const response = await fetch(`${API_URL}/calor/certificate-range`, {
    method: 'PUT',
    headers: getAuthHeaders(true),
    body: JSON.stringify({ rangeStart, rangeEnd, numberingDisabledForTesting }),
  });

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body?.error || `Failed to save certificate range (${response.status})`);
  }
  return body;
}
